import CodeMirror from 'codemirror'
import "codemirror/addon/hint/show-hint"

function tachyonHint(editor, options) {
        
    // if(Object.keys(entities).length > 30000) return;
    
    var line = editor.line;
    var distances = quark.reachable(line)
    var cur = editor.getCursor(), 
        curLine = editor.getLine(cur.line);
    var token = editor.getTokenAt({ch: cur.ch + 1, line: cur.line})
    var start = token.start + token.string.match(/^\s*/)[0].length,
        end = token.end;
    var curWord = quark.remove_refs(curLine.slice(start, end))
    var predicateEnd = token.type == 'predicate' && cur.ch == token.end;
    

    if(predicateEnd){ curWord = '' }

    function pick(cm, data, completion){
        // var rep = quark.tok(completion.entity)
        var rep = cm.react.lookup_text(completion.entity)
        cm.replaceRange(rep, data.from, data.to)
        cm.react.hyperlinkRange(cm.indexFromPos(data.from), completion.entity)
        // cm.react.hyperlinkRange(data.from,
        //     cm.posFromIndex(
        //         cm.indexFromPos(data.from) + rep.length
        //     ), completion.entity)
    }
    // console.log(_.sortBy(_.values(entities)
    //         .filter(k => k.type == 'text' && k.parent == '__root__')
    //         .map(k => _.assign({distance: distances[k.id]}, k))
    //         .filter(k => k.distance < 10)
    //     , 'distance'))
    var line_edges = quark.enlist(line).map(k => quark.string_reverse(k.id))
    
    // parents shouldnt be shown with high priority
    delete distances[line.parent];

    var list = []
    if(line.type == 'text' && token.type == 'hashtag'){

        
        // start++
        // list = [
        //     // {text: '#' + 'yolo', displayText: '#yolo', entity: 'yolo'}
        // ]
        let hashtag = token.string.slice(1).replace(/_/g, ' ');

        list = _.sortBy(
            _.values(entities)
            .filter(k => 
                k.type == 'text' && 
                k.parent == '__root__' &&
                k.text.toLowerCase().startsWith(hashtag.trim().toLowerCase()) &&
                enlist(k).some(e => 
                    !(e.type == 'cluster' && 
                        enlist(e).every(f => f.ref == line.id) ))
            )
        ).slice(0, 20).map(k => ({
            text: '#' + k.text.replace(/ /g, '_'),
            displayText: '#' + k.text.replace(/ /g, '_'),
            entity: k.id,
            className: 'hashtag',
            // hint: pick
        }))

        if(list.length > 0 && list[0].text == token.string) list = [];


    }else if((line.type == 'cluster' || line.type == 'edge') && !line.id.startsWith('fake-')){


        var cluster = line.type == 'cluster' ? line : get(line.parent);
        var blacklist = enlist(cluster).map(k => k.ref)

        if(cluster.predicate == ''){
            // seed this based on the other unlabeled edges
            var seed = _.mapValues(_.groupBy( _.flatten(
                quark.edges(quark.get(cluster.parent))
                .filter(k => quark.get(k.parent).predicate == '')
                .map(k => quark.edges(quark.get(k.ref))))
                .map(k => quark.get(k.parent))
                .filter(k => k.predicate),
                    k => quark.canonicalize_predicate(k.predicate)
                ), k => k.length)
        }else{
            // seed this based on the current cluster's predicate
            var seed = {}
            seed[quark.canonicalize_predicate(quark.invert_predicate(cluster.predicate))] = 1;
        }
        var {ents, preds} = quark.type_graph(seed)
        var aliases = _.values(entities).filter(k => k.type == 'alias')
        var cw = curWord.trim().toLowerCase()

        if(cw.length < 2) return;

        list = _.sortBy(
            _.values(entities)
            .filter(k => 
                !blacklist.includes(k.id) &&
                k.type == 'text' && 
                k.parent == '__root__' &&
                (
                    k.text.toLowerCase().startsWith(cw) || 
                    aliases.filter(e => e.parent == k.id)
                        .some(e => e.alias.toLowerCase().startsWith(cw))
                ) &&
                // check that this edge wasn't created by this line
                _.difference(
                    quark.edges(k).map(e => e.id),
                    line_edges
                ).length > 0 
                // && (distances[k.id] || 100) > 5
                    
            ),
                k => - (ents[k.id] || 0) 
                    + (distances[k.id] || 100)
                // k => Math.abs((distances[k.id] || 100) - 8) 
                //     - quark.degree(k) / 200
                //     + k.id.length / 100
            )
        .slice(0, 20).map(k => ({
            text: quark.tok(k.id),
            entity: k.id,
            displayText: k.text,
            className: 'entity',
            hint: pick
        }))

    }else if(line.type == 'text' || (token.type == 'predicate' && !predicateEnd)){
        var seed = _.mapValues(_.groupBy(quark.edges(quark.get(line.parent))
            .map(k => quark.get(k.parent))
            .filter(k => k.predicate != '')
            .map(k => quark.canonicalize_predicate(k.predicate))),
        k => k.length)
        var {ents, preds} = quark.type_graph(seed)
        var allpred = quark.graph.predicates()
        
        list = _.unique(_.sortBy(_.keys(allpred), preds).map(
            k => quark.clean_predicate(allpred[k][0]))
            .filter(k => k.toLowerCase().startsWith(curWord.trim().toLowerCase())))
            .slice(0, 20).map(k => ({
                text: k + ': ',
                className: 'edgelabel'
            }))
    }else if(line.type == 'path' || line.type == 'intersect'){
        list = _.sortBy(
            _.values(entities)
            .filter(k => 
                k.type == 'text' && 
                k.parent == '__root__' &&
                k.text.toLowerCase().startsWith(curWord.trim().toLowerCase()))
        ).slice(0, 20).map(k => ({
            text: quark.tok(k.id),
            entity: k.id,
            displayText: k.text,
            className: 'entity',
            hint: pick
        }))
    }

    // dont popup suggestions if exact match found
    // if(list.some(k => 
    //     k.text.toLowerCase() == curWord.trim().toLowerCase()
    // )) list = [];

    
    if(!quark.is_empty(quark.find_name(curWord.trim()), line)) list = [];

    // dont show list if we've already got a tokenized thing
    if(token.string.indexOf('<ref-') != -1) list = [];

    if(line.id == '__root__' && line.type == 'search') list = [];

    return {
        list: list, 
        from: CodeMirror.Pos(cur.line, start + (predicateEnd ? 1 : 0)), 
        to: CodeMirror.Pos(cur.line, end)
    };
}

CodeMirror.registerHelper("hint", "rootmode", tachyonHint);
CodeMirror.registerHelper("hint", "leafmode", tachyonHint);
CodeMirror.registerHelper("hint", "edgemode", tachyonHint);


// WEBPACK FOOTER //
// ./src/editor/hint.js